import { Component, ElementRef, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {
  @ViewChild('dynamicTemplate') dynamicTemplate!:ElementRef<HTMLDivElement>;
  public eventListnerProceed:any;
  public isDefaultFooter:boolean = false;
  public isTermAndConditionOpen:boolean = false;
  public isTermsAndConditionAccept:boolean = true;
  public screenTemplate:any;

  public temp_deatils:any = {};

  constructor(public notifier: NotifierService,public qService:QuestionService, public aService:AnswerService, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    setTimeout(() =>{
      this.screenTemplate = this.qService.screenTemplate;
      this.temp_deatils = this.qService.screenTemplateDetails;
    },100)
    // let defaultTemp  = this.getMeeshoTemp();
    // let defaultTemp =  this.getDefaultTemplate();
    // this.qService.screenTemplate = this.qService.sanitizer.bypassSecurityTrustHtml(defaultTemp);

  }

  // ngAfterViewInit():void{
  //     setTimeout(() =>{
  //     this.eventListnerProceed = document.getElementById('proceedBtn');
  //     if(this.eventListnerProceed){
  //       this.eventListnerProceed.addEventListener('click', () => {
  //         this.proceed();
  //       });
  //     }
  //   },500)
  // }


  // getMeeshoTemp(){
  //   return `<div style="display: flex; flex-direction: column;">
  //       <div style="display: flex; flex-direction: column; align-items: center;">
  //           <div style="margin-top: 10px;">
  //               <img style="height: 150px; width: 275px;" src="https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714631934_meeshocrowniticon.jpg" alt="Logo">
  //           </div>
  //           <div style="margin: 5px auto; font-family:'Roboto',sans-serif; font-size:20px; font-weight: 600; text-align: center;">
  //               Share your opinions by completing Surveys to earn upto
  //           </div>
  //           <div  style="color: #2875e7; font-family:'Roboto',sans-serif; font-size:25px; font-weight: 600; text-align: center;">
  //               &#8377;100
  //           </div>
  //       </div>
  //       <div>
  //           <div style="margin: 10px; border:1px solid #c4c4c4; padding: 10px 25px; border-radius: 25px;">
  //               <div style="display: flex; align-items: center; margin: 5px 0px;">
  //                   <div>
  //                       <img style="width: 25px; height: 25px; margin-right:10px;" src="https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714634810_GreenCheckPNGImageHD.png" alt="greenCheck">
  //                   </div>
  //                   <div style="font-family:'Roboto',sans-serif; font-size:20px; font-weight: 600">Do's</div>
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   1) Read the question carefully 
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   2) Think before answering
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   3) Answer sinceraly and truthfully
  //               </div>
  //           </div>
  //           <div style="margin: 10px; border:1px solid #c4c4c4; padding: 10px 25px; border-radius: 25px;">
  //               <div style="display: flex; align-items: center; margin: 5px 0px;">
  //                   <div>
  //                       <img style="width: 25px; height: 25px; margin-right:10px;" src="https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714635686_redxlineicon.png" alt="greenCheck">
  //                   </div>
  //                   <div style="font-family:'Roboto',sans-serif; font-size:20px; font-weight: 600">Dont's</div>
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   1) Don't rush through the survey
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   2) Don't write gibberish in textual questions
  //               </div>
  //               <div style="margin: 5px 0px 0px 0px; font-family:'Roboto',sans-serif; font-size:17px; font-weight: 500;">
  //                   3) Upload only the image that is asked in the survey
  //               </div>
  //           </div>
  //       </div>
  //   </div>`;
  // }

  // getDefaultTemplate(){
  //   return `<div 
  //     style="background-color: #fff; 
  //     align-items: center; display: flex; 
  //     flex-direction: column; justify-content: space-between; align-items: center; text-align: center;"
  //   >
  //     <div class="ques-cont">
  //       <div>
  //           <img style="margin-top: 15px;" src="https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714017537_m2x.png" alt="" />
  //       </div>
  //       <div class="survey-head" style="margin: 10px; color: #0d6efd ; font-family:'Roboto',sans-serif; font-size:25px; line-height:25px; font-weight: 700;">
  //           This is a Demographic survey
  //       </div>
  //       <div class="survey-head" style="margin: 10px; color: #000 ; font-family:'Roboto',sans-serif; font-size:20px; line-height:25px; font-weight: 700;">
  //           You will be asked to complete
  //           your profile firstly then after you will be redirected to the main survey.
  //       </div>
  //       <div class="survey-head" style="margin: 10px; color: #6c757d  ; font-family:'Roboto',sans-serif; font-size:20px; line-height:25px; font-weight: 600;">
  //           No rewards are given on 
  //           completing profile.
  //       </div>
  //       <div class="mt-4">
  //           <img class="Image-Section" style="margin-top: 10px; width: 250px; height: 180px;" src="https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714017647_group22x.png" alt="" />
  //       </div>
  //     </div>
  //   </div>`
  // }



  proceed(){
    var data = {"proceed":true};
    if(this.temp_deatils && this.temp_deatils['isTermandCond']){
      if(this.isTermsAndConditionAccept){
        this.activatedRoute.queryParams
        .subscribe(params => {
            this.qService.initSurvay({"survey_id":params['survey_id'],"request_id":this.qService.utg_id,"sid":params['sid']}); 
            this.qService.submitSingleAnswer(data);
        });
      }else{
        this.notifier.notify('error','Please Accept Terms and conditions')
      }
    }else{
      this.activatedRoute.queryParams
      .subscribe(params => {
          this.qService.initSurvay({"survey_id":params['survey_id'],"request_id":this.qService.utg_id,"sid":params['sid']});  
          this.qService.submitSingleAnswer(data);
      });
    }
  }

  openPopup(){
    this.isTermAndConditionOpen = true;
  }

  closePopup(){
    this.isTermAndConditionOpen = false;
  }

}
